import {Injectable, OnDestroy} from '@angular/core';
import {ConfigService} from './config.service';

export interface RefinerUser {
    id: string;
    email: string;
    name: string;
    [key: string]: unknown;
}

@Injectable()
export class RefinerService implements OnDestroy {
    private get refinerId(): string {
        return window.REFINER_ID ?? '';
    }
    private script?: HTMLScriptElement;
    private loaded = false;
    private loading = false;

    constructor(private config: ConfigService) {
    }

    init(): void {
        if (!this.config.showRefinerSurvey || !this.refinerId || this.loaded || this.loading) return;
        this.loading = true;

        const queue = (Array.isArray(window._refinerQueue) ? window._refinerQueue : []) as unknown[][];
        window._refinerQueue = queue;

        const refiner = (window._refiner = (...args: unknown[]) => {
            queue.push(args);
        });

        refiner('setProject', this.refinerId);

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://js.refiner.io/v001/client.js';

        script.onload = () => {
            this.loaded = true;
            this.loading = false;
        };

        script.onerror = () => {
            this.cleanupScript(script);
        };

        this.script = script;

        document.head.appendChild(script);
    }

    identifyUser(user: RefinerUser): void {
        if (!this.config.showRefinerSurvey) {
            return;
        }

        this.init();
        window._refiner?.('identifyUser', user);
    }

    ngOnDestroy(): void {
        if (this.script) {
            this.cleanupScript(this.script);
        }
    }

    private cleanupScript(script: HTMLScriptElement): void {
        script.onload = null;
        script.onerror = null;
        script.parentNode?.removeChild(script);
        this.script = undefined;
        this.loaded = false;
        this.loading = false;
    }

    resetUser(): void {
        window._refiner?.('resetUser');
    }
}
